import { render } from "./ViewTableComponent2.vue?vue&type=template&id=ac0e334e"
import script from "./ViewTableComponent2.vue?vue&type=script&lang=js"
export * from "./ViewTableComponent2.vue?vue&type=script&lang=js"
script.render = render

export default script